module.exports = __webpack_public_path__ + "Proxima Nova Bold.7237890d70483536a94e.woff2";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/ucla-prrla/ucla-prrla/ucla-prrla/fonts/Proxima Nova Bold.woff2
// module id = ../../../../../fonts/Proxima Nova Bold.woff2
// module chunks = 2